module.exports = __webpack_public_path__ + "img/@logo_lge.bde92f88.png";